module.exports = __webpack_public_path__ + "static/img/tick-2.564121cf.svg";